import React from 'react';
import { Icon } from './Icon.js';
export const IconBook = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M18.002 2.04785L5 4.01562V8H3V2.2959L3.85059 2.16699L18.0039 0.0253906L18.002 2.04785Z", fill: "currentColor", "data-stroke": "none" }),
        React.createElement("path", { d: "M8 6V22", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M20 6L4 6L4 22H20L20 6Z", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M16 14H12V10H16V14Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconBook.js.map